import food1 from "../assets/img/food/rice/បាយឆាសាច់ក្រក.jpg";
import food2 from "../assets/img/food/rice/បាយមាន់ចៀន.jpg";
import food3 from "../assets/img/food/rice/បាយសាច់ជ្រូកមែនទិក.jpg";
import food4 from "../assets/img/food/rice/បាយសាច់ផាក់ឡូវ.jpg";
import food5 from "../assets/img/food/rice/បាយមាន់ហៃណាំ.jpg";
import food6 from "../assets/img/food/rice/បាយសាច់មាន់ឆាម្រះព្រៅ.jpg";
import food7 from "../assets/img/food/rice/បាយឆាឡកឡាក់.jpg";
import rice1 from "../assets/img/food/rice/rice1.png";
import rice2 from "../assets/img/food/rice/rice2.png";
import rice3 from "../assets/img/food/rice/rice3.jpg";
import rice4 from "../assets/img/food/rice/rice4.jpg";
import rice5 from "../assets/img/food/rice/rice5.jpg";
import rice6 from "../assets/img/food/rice/rice6.jpg";
import rice7 from "../assets/img/food/rice/rice7.jpg";
import rice8 from "../assets/img/food/rice/rice8.jpg";
import rice9 from "../assets/img/food/rice/rice9.jpg";
import rice10 from "../assets/img/food/rice/rice10.jpg";
import rice11 from "../assets/img/food/rice/rice11.jpg";
//hot
import drink1 from "../assets/img/drink/hot/Hot Americano_M.jpg";
import drink2 from "../assets/img/drink/hot/Hot Cappuccino-M.jpg";
import drink3 from "../assets/img/drink/hot/Hot Caramel Latte - M.jpg";
import drink4 from "../assets/img/drink/hot/Hot Expresso_L.jpg";
//ice
import drink5 from "../assets/img/drink/ice/Iced Americano-L-01.jpg";
import drink6 from "../assets/img/drink/ice/Iced Cappuccino-L-01.jpg";
import drink7 from "../assets/img/drink/ice/Iced Caramel Latte-L-01.jpg";
import drink8 from "../assets/img/drink/ice/Iced Coconut Coffe-L-01.jpg";
import drink9 from "../assets/img/drink/ice/Iced Latte-L-01.jpg";
import drink10 from "../assets/img/drink/ice/Iced Matcha Latte-L-01.jpg";
import drink11 from "../assets/img/drink/ice/Iced Mocha-L-01.jpg";
import drink12 from "../assets/img/drink/ice/Iced Vanilla Latte-L-01.jpg";
import drink13 from "../assets/img/drink/ice/Iced Mango Coffe-01.jpg";
import drink34 from "../assets/img/drink/ice/Iced Heney Lemon Tea -L-01.jpg";
//Milk
import drink14 from "../assets/img/drink/milk-tea/Green Milk Tea - L.jpg";
import drink16 from "../assets/img/drink/milk-tea/Jasmine Tea Cup-L-01.jpg";
import drink17 from "../assets/img/drink/milk-tea/Jelly Green Tea - M-01.jpg";
import drink18 from "../assets/img/drink/milk-tea/Mantic Tea Cup Black tea_L.jpg";
import drink19 from "../assets/img/drink/milk-tea/Oolong Tea Cup-L-01.jpg";
import drink20 from "../assets/img/drink/milk-tea/Passion Fresh Milk - L.jpg";
import drink21 from "../assets/img/drink/milk-tea/Strawberry Jasmine Tea-01.jpg";
import drink22 from "../assets/img/drink/milk-tea/Strawberry Matcha Latte - M-01.jpg";

//smoothie
import drink23 from "../assets/img/drink/smoothie/Avocado Smoothie - M.jpg";
import drink24 from "../assets/img/drink/smoothie/Banana Smoothie-M-01.jpg";
import drink25 from "../assets/img/drink/smoothie/Coffe Frappe-M-01.jpg";
import drink26 from "../assets/img/drink/smoothie/Durian Smoothie - M.jpg";
import drink27 from "../assets/img/drink/smoothie/Jackfruit Smoothie - M.jpg";
import drink28 from "../assets/img/drink/smoothie/Kiwi Smoothie-M-01.jpg";
import drink29 from "../assets/img/drink/smoothie/Mango Smoothie - M.jpg";
import drink30 from "../assets/img/drink/smoothie/Passion Smoothie-01.jpg";
import drink31 from "../assets/img/drink/smoothie/Soursop Smoothie - M-01.jpg";
import drink32 from "../assets/img/drink/smoothie/Strawberry Smoothie-M-01.jpg";
import drink33 from "../assets/img/drink/smoothie/Taro Mix Coconut_M-01.jpg";
//Italian Soda
import drink35 from "../assets/img/drink/soda/Kiwi Soda-M-01.jpg";
import drink36 from "../assets/img/drink/soda/Passion Soda-M-01.jpg";
import drink37 from "../assets/img/drink/soda/Strawberry Soda-M-01.jpg";
//soup
import soup1 from "../assets/img/food/soup/soup1.jpg";
import soup2 from "../assets/img/food/soup/soup2.jpg";
import soup3 from "../assets/img/food/soup/soup3.jpg";
import soup4 from "../assets/img/food/soup/soup4.jpg";
import soup5 from "../assets/img/food/soup/soup5.jpg";
import soup6 from "../assets/img/food/soup/soup6.jpg";
import soup7 from "../assets/img/food/soup/soup7.jpg";
import soup8 from "../assets/img/food/soup/soup8.jpg";
import soup9 from "../assets/img/food/soup/soup9.jpg";
import soup10 from "../assets/img/food/soup/soup10.jpg";
import soup11 from "../assets/img/food/soup/soup11.jpg";
import soup12 from "../assets/img/food/soup/soup12.jpg";
import soup13 from "../assets/img/food/soup/soup13.jpg";
import soup14 from "../assets/img/food/soup/soup14.jpg";
import soup15 from "../assets/img/food/soup/soup15.jpg";
import soup16 from "../assets/img/food/soup/soup16.jpg";
import soup17 from "../assets/img/food/soup/soup17.jpg";
import soup18 from "../assets/img/food/soup/soup18.jpg";
import soup19 from "../assets/img/food/soup/soup19.jpg";
import soup20 from "../assets/img/food/soup/soup20.jpg";
import soup21 from "../assets/img/food/soup/soup21.jpg";
import soup22 from "../assets/img/food/soup/soup22.jpg";
import soup23 from "../assets/img/food/soup/soup23.jpg";
//group Fried
import fried1 from "../assets/img/food/fried/fried1.jpg";
import fried2 from "../assets/img/food/fried/fried2.jpg";
import fried3 from "../assets/img/food/fried/fried3.jpg";
import fried4 from "../assets/img/food/fried/fried4.jpg";
import fried5 from "../assets/img/food/fried/fried5.jpg";
// import fried6 from "../assets/img/food/fried/fried6.jpg";
import fried7 from "../assets/img/food/fried/fried7.jpg";
import fried8 from "../assets/img/food/fried/fried8.jpg";
import fried9 from "../assets/img/food/fried/fried9.jpg";
import fried10 from "../assets/img/food/fried/fried10.jpg";
import fried11 from "../assets/img/food/fried/fried11.jpg";
import fried12 from "../assets/img/food/fried/fried12.jpg";
import fried13 from "../assets/img/food/fried/fried13.jpg";
import fried14 from "../assets/img/food/fried/fried14.jpg";
import fried15 from "../assets/img/food/fried/fried15.jpg";

const foodCard = [
  {
    image: food1,
    title: "បាយឆាសាច់ក្រក",
    desc: "FRIED RICE WITH SAUSAGE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: food2,
    title: "បាយមាន់ចៀន (មាន់ស្រុក)",
    desc: "CHICKEN FRIED RICE",
    price: "4.50",
    category: "Rice",
  },
  {
    image: food3,
    title: "បាយសាច់ជ្រូកមែនទឹក (ស្លឹកចេក)",
    desc: "PORK RICE MANTIC",
    price: "2.50",
    category: "Rice",
  },
  {
    image: food4,
    title: "បាយសាច់ផាក់ឡូវ",
    desc: "RICE PAK LOV",
    price: "3.50",
    category: "Rice",
  },
  {
    image: food5,
    title: "បាយមាន់ហៃណាំ",
    desc: "HAINANESE CHICKEN RICE",
    price: "4.50",
    category: "Rice",
  },
  {
    image: food6,
    title: "បាយសាច់មាន់ឆាម្រះព្រៅ",
    desc: "BASIL CHICKEN FRIED WITH RICE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: food6,
    title: "បាយសាច់ជ្រូកឆាម្រះពៅ",
    desc: "BASIL PORK FRIED WITH RICE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: food7,
    title: "បាយឆាឡកឡាក់",
    desc: "LOK LAK BEEF WITH FRIED RICE",
    price: "3.80",
    category: "Rice",
  },
  {
    image: rice1,
    title: "បាយសាច់ជ្រកឆាហីរ",
    desc: "SPICY PORK STYLE WITH STEAM RICE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: rice2,
    title: "បាយសម្រូប",
    desc: "BROWN RICE ",
    price: "0.80",
    category: "Rice",
  },
  {
    image: rice3,
    title: "បាយទ្រូងមាន់បំពងស្រួយ",
    desc: "CRISPY CHICKEN BREAST WITH STEAM RICE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: rice4,
    title: "បាយខគោ",
    desc: "BRAISSED BEEF WITH STEAM RICE",
    price: "4.50",
    category: "Rice",
  },
  {
    image: rice5,
    title: "បាយប៊ី",
    desc: "RICE BEE",
    price: "4.00",
    category: "Rice",
  },
  {
    image: rice6,
    title: "បាយសាច់ជ្រូកពងទាក្រឡក",
    desc: "PORK RICE WITH'SCRAMBLED EGG ",
    price: "3.00",
    category: "Rice",
  },
  {
    image: rice7,
    title: "បាយឆាសាច់គោ",
    desc: "BEEF FRIED RICE",
    price: "3.00",
    category: "Rice",
  },
  {
    image: rice8,
    title: "បាយឆា មែនទឹក",
    desc: "MANTIC FRIED RICE ",
    price: "3.80",
    category: "Rice",
  },
  {
    image: rice9,
    title: "បាយទ្រូងទាពិសេស",
    desc: "SPECIAL DUCK BREAST RICE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: rice10,
    title: "បាយឆាសាច់ក្រក",
    desc: "FRIED RICEWITH SAUSAGE",
    price: "3.50",
    category: "Rice",
  },
  {
    image: rice11,
    title: "បាយសាច់ផាក់ឡូវ",
    desc: "RICE PAK LOV",
    price: "3.50",
    category: "Rice",
  },
  // group fried
  {
    image: fried1,
    title: "មីឆាសាច់គោ",
    desc: "FRIED NOODLE WITH BEEF",
    price: "3.00",
    category: "Fried",
  },
  {
    image: fried2,
    title: "លតឆាសាច់គោ",
    desc: "FRIED PIN NOODLE WITH BEEF",
    price: "3.50",
    category: "Fried",
  },
  {
    image: fried3,
    title: "ផាត់ ថៃ",
    desc: "PAD THAI",
    price: "3.80",
    category: "Fried",
  },
  {
    image: fried4,
    title: "មីកន្តាំងឆាសាច់គោ",
    desc: "KONTANG NOODLE BEEF",
    price: "3.00",
    category: "Fried",
  },
  {
    image: fried5,
    title: "ស្នាហ្គេទីទឹកប៉េងប៉ោះ",
    desc: "SPAGHETI TOMATO WITH CHEESE",
    price: "3.00",
    category: "Fried",
  },
  // {
  //   image: fried6,
  //   title: "ដំឡូងបារាំង",
  //   desc: "FRENCH FRIES",
  //   price: "3.00",
  //   category: "Fried",
  // },
  {
    image: fried7,
    title: "ដំឡូងបារាំង",
    desc: "POTATO Fried",
    price: "3.00",
    category: "Fried",
  },
  {
    image: fried8,
    title: "នំប៉័ងផាកឡូវ",
    desc: "PHAK LOV BREAD",
    price: "2.50",
    category: "Fried",
  },
  {
    image: fried9,
    title: "នំបូងប៉ាតេ",
    desc: "PATE BREAD",
    price: "2.50",
    category: "Fried",
  },
  {
    image: fried10,
    title: "ប៊ីហ្គីសាច់គោ",
    desc: "CHEESE BEEF BURGER",
    price: "2.90",
    category: "Fried",
  },
  {
    image: fried11,
    title: "សាំងវិច",
    desc: "SANDWICH",
    price: "1.70",
    category: "Fried",
  },
  {
    image: fried12,
    title: "សាំងវិចកៀប",
    desc: "SANDWICH",
    price: "1.25",
    category: "Fried",
  },
  {
    image: fried13,
    title: "ពោតបំពង",
    desc: "FRIED NOODLE WITH BEEF",
    price: "3.00",
    category: "Fried",
  },
  {
    image: fried14,
    title: "ភីហ្សាគ្រឿងសមុទ្រ",
    desc: "SEAFOOD PIZZA ( M) ",
    price: "7.20",
    category: "Fried",
  },
  {
    image: fried15,
    title: "ភីហ្សាសាច់ហែម (M)",
    desc: "HAWAIIAN PIZZA (HAM & PINEAPPLE)",
    price: "7.20",
    category: "Fried",
  },
  //drink
  {
    image: drink1,
    title: "អាមេរិកកាណូ",
    desc: "Hot Americano - (L)",
    price: "2.80",
    category: "Group Hot",
  },
  {
    image: drink2,
    title: "កាពូឈឺណូ",
    desc: "Hot Cappuccino - (L)",
    price: "2.80",
    category: "Group Hot",
  },
  {
    image: drink3,
    title: "ខារ៉ាមែលឡាតេ",
    desc: "Iced Caramel Latte - (L)",
    price: "2.90",
    category: "Group Hot",
  },
  {
    image: drink4,
    title: "អ៊ិចប្រ៊េសសូ",
    desc: "Hot Expresso - (L)",
    price: "2.50",
    category: "Group Hot",
  },
  {
    image: drink4,
    title: "ឡាតេ",
    desc: "Hot Latte - (L)",
    price: "2.80",
    category: "Group Hot",
  },
  //group ice
  {
    image: drink5,
    title: "អាមេរិកកាណូ",
    desc: "Iced Americano - (L)",
    price: "2.80",
    category: "Group Iced",
  },
  {
    image: drink6,
    title: "កាពូឈឺណូ",
    desc: "Iced Cappuccino - (L)",
    price: "2.80",
    category: "Group Iced",
  },
  {
    image: drink7,
    title: "ខារ៉ាមែលឡាតេ",
    desc: "Iced Caramel Latte - (L)",
    price: "3.90",
    category: "Group Iced",
  },
  {
    image: drink8,
    title: "កាហ្វេដូងក្រអូប",
    desc: "Iced Coconut Coffee - (L)",
    price: "3.90",
    category: "Group Iced",
  },
  {
    image: drink9,
    title: "ឡាតេ",
    desc: "Iced Latte - (L)",
    price: "2.80",
    category: "Group Iced",
  },
  {
    image: drink10,
    title: "ម៉ាតឆាឡាតេ",
    desc: "Iced Matcha Latte - (L)",
    price: "2.80",
    category: "Group Iced",
  },
  {
    image: drink11,
    title: "ម៉ូកា",
    desc: "Iced Mocha - (L)",
    price: "3.90",
    category: "Group Iced",
  },
  {
    image: drink12,
    title: "វ៉ាន់នីឡាឡាតេ",
    desc: "Iced Vanilla Latte - (L)",
    price: "3.90",
    category: "Group Iced",
  },
  {
    image: drink13,
    title: "កាហ្វេស្វាយ",
    desc: "Iced Mango Coffee - (M)",
    price: "2.80",
    category: "Group Iced",
  },
  {
    image: drink34,
    title: "តែក្រូចឆ្មាទឹកឃ្មុំ",
    desc: "Iced Honey Lemon Tea - (L)",
    price: "3.20",
    category: "Group Iced",
  },
  //milk
  {
    image: drink14,
    title: "តែបៃតងទឹកដោះគោ",
    desc: "Green Milk Tea - (L)",
    price: "2.80",
    category: "Milk",
  },
  {
    image: drink16,
    title: "តែម្លិះដោះគោ",
    desc: "Jasmine Tea Cup - (L)",
    price: "3.20",
    category: "Milk",
  },
  {
    image: drink17,
    title: "តែបៃតងទឹកដោះគោចាហ៊ូយ",
    desc: "Jelly Green Tea - (M)",
    price: "2.80",
    category: "Milk",
  },
  {
    image: drink18,
    title: "តែទឹកដោះគោមែនទឹក (តែខ្មៅ)",
    desc: "Mantic Tea Cup black tea - (L)",
    price: "3.20",
    category: "Milk",
  },
  {
    image: drink19,
    title: "តែដោះគោអ៊ូឡូង",
    desc: "Oolong Tea Cup - (L)",
    price: "3.20",
    category: "Milk",
  },
  {
    image: drink20,
    title: "ផាសិនដោះគោ",
    desc: "Passion Milk - (L)",
    price: "3.20",
    category: "Milk",
  },
  {
    image: drink21,
    title: "ស្ត្ររបឺរំទឹកដោះគោ",
    desc: "Strawberry Jasmine Tea - (M)",
    price: "2.80",
    category: "Milk",
  },
  {
    image: drink22,
    title: "ស្ត្ររបីរម៉ាត់ឆាឡាតេ",
    desc: "Strawberry Matcha Latte - (M)",
    price: "2.80",
    category: "Milk",
  },

  //smoothie
  {
    image: drink23,
    title: "ប៊ឹក្រឡុក",
    desc: "Avocado smoothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink24,
    title: "ចេកក្រឡុក",
    desc: "Banana Smoothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink25,
    title: "កាហ្វេក្រឡក",
    desc: "Coffee Frappe - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink26,
    title: "ទុរេនក្រឡុក",
    desc: "Durian Smoothie - (M)",
    price: "4.20",
    category: "Smoothie",
  },
  {
    image: drink27,
    title: "ខ្មុរក្រឡុក",
    desc: "Jackfruit Smoothie - (M)",
    price: "4.20",
    category: "Smoothie",
  },
  {
    image: drink28,
    title: "ឃីវីក្រឡុក",
    desc: " Kiwi Soothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink29,
    title: "ស្វាយក្រឡុក",
    desc: "Mango Smbothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink30,
    title: "ផាសិនក្រឡុក",
    desc: "Passion Smoothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink31,
    title: "ទៀបបារាំងក្រឡុក",
    desc: "Soursop Smoothre - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink32,
    title: "ស្ត្ររប៊័រក្រឡុក",
    desc: "Strawberry Smoothie - (M)",
    price: "3.80",
    category: "Smoothie",
  },
  {
    image: drink33,
    title: "ត្រាវលាយដួងក្រឡុក",
    desc: "Taro Mix Coconut - (M)",
    price: "4.20",
    category: "Smoothie",
  },
  //Italian Soda
  {
    image: drink35,
    title: "ឃីវីសូដា",
    desc: "Kiwi Soda - (L)",
    price: "2.90",
    category: "Italian Soda",
  },
  {
    image: drink37,
    title: "ស្ត្របឺរីសូដា",
    desc: "Strawberry Soda - (L)",
    price: "2.90",
    category: "Italian Soda",
  },
  {
    image: drink36,
    title: "ផាសិនសូដា",
    desc: "Passion Soda - (L)",
    price: "2.90",
    category: "Italian Soda",
  },
  //soup
  {
    image: soup1,
    title: "ស៊ុបពងមាន់",
    desc: "EGG SOUP",
    price: "1.50",
    category: "Soup",
  },
  {
    image: soup2,
    title: "ស៊ុបក្តាម",
    desc: "CRAB SOUP",
    price: "2.50",
    category: "Soup",
  },
  {
    image: soup3,
    title: "គុយទាវស៊ុបសាច់គោ",
    desc: "BEEF RICE NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup3,
    title: "គុយទាវស៊ុបសាច់ជ្រូក",
    desc: "PORK RICE NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup4,
    title: "គុយទាវស៊ុបផាក់ឡូវ",
    desc: "PHAK LOV RICE NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup5,
    title: "គុយទាវទឹកខ្មៅ",
    desc: "BLACK SOUP NOODLE",
    price: "4.20",
    category: "Soup",
  },
  {
    image: soup6,
    title: "គុយទាវគ្រឿងសមុទ្រ មែនទឹក",
    desc: "MANTIC SEAFOOD NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup7,
    title: "មីស៊ុបសាច់គោ",
    desc: "BEEF NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup7,
    title: "មីស៊ុបសាច់ជ្រូក",
    desc: "PORK NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup8,
    title: "មីស៊ុបផាក់ឡវ",
    desc: "PHAK LOV NOODLE SOUP",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup9,
    title: "មីទាផាក់ឡវ",
    desc: "DUCK MEAT PHAK LOV NOODLE SOUP",
    price: "3.80",
    category: "Soup",
  },
  {
    image: soup10,
    title: "មីស៊ុបគីមឈីសាច់ជ្រូក",
    desc: "KIMCHI STEW WITH PORK",
    price: "4.20",
    category: "Soup",
  },
  {
    image: soup11,
    title: "មីគោកសាច់គោ",
    desc: "DRIED NOODLE WITH BEEF",
    price: "4.10",
    category: "Soup",
  },
  {
    image: soup12,
    title: "ហ្វីទឹកពុះសាច់គោអូស្ត្រាលី",
    desc: "SPECIAL PHO + AUSTRALIAN BEEF",
    price: "9.50",
    category: "Soup",
  },
  {
    image: soup13,
    title: "ហ្វីពិសេស មែនទឹក",
    desc: "PHO AUSTRALIAN BEEF BIG BOWL",
    price: "6.50",
    category: "Soup",
  },
  {
    image: soup14,
    title: "ហ្វីសាច់គោ",
    desc: "PHO BEEF",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup15,
    title: "មីគោកសាច់ជ្រូកចិញ្ច្រាំ",
    desc: "DRIED NOODLE WITA MINCED PORK",
    price: "4.10",
    category: "Soup",
  },
  {
    image: soup16,
    title: "គុយទាវខគោ",
    desc: "RICE NOODLE BRAISED BEEF",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup16,
    title: "មីខគោ",
    desc: " NOODLE BRAISED BEEF",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup17,
    title: "នំប័ុងខគោ",
    desc: "BRAISED BEEF WITH BREAD",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup18,
    title: "បាយខគោ",
    desc: "BRAISSED BEEF WITH STEAM RICE",
    price: "4.50",
    category: "Soup",
  },
  {
    image: soup19,
    title: "នំបញ្ចុកមែនទឹកជើងមាន់",
    desc: "MANTIC KHMER NOODLE WITH CHICKEN",
    price: "4.20",
    category: "Soup",
  },
  {
    image: soup20,
    title: "នំបញ្ជុកសម្លរខ្មែរ",
    desc: "NORM BANH JORK KHMER FISH SOUP",
    price: "3.00",
    category: "Soup",
  },
  {
    image: soup21,
    title: "បបរត្រី",
    desc: "FISH PORRIDGE",
    price: "3.80",
    category: "Soup",
  },
  {
    image: soup22,
    title: "បបរគ្រឿងសមុទ្រ",
    desc: "SEAFOOD PORRIDGE",
    price: "4.30",
    category: "Soup",
  },
  {
    image: soup23,
    title: "បបរមាន់",
    desc: "CHICKEN PORRIDGE",
    price: "3.80",
    category: "Soup",
  },
  {
    image: soup23,
    title: "បបរខកង្កែប",
    desc: "FROG PORRIDGE",
    price: "4.10",
    category: "Soup",
  },
];
export { foodCard };
